// stores/counter.js
import { defineStore } from 'pinia';
import axios from 'axios';

//Store
export const useStore = defineStore('kirby', {
  state: () => {
    return {
      site: {},
      page: {},
      pages: {},
      api: "/api/cachedKQL",
      query: {
        query: "site",
        select: {
          url: true,
          titteli: "site.titteli",
          avoinna: "site.avoinna.kirbytext",
          cover: "site.cover",
          intronotsikko: "site.intronotsikko",
          introteksti: "site.introteksti",
          tyonaytekuvateksti: "site.tyonaytekuvateksti",
          tyonayte: "site.tyonayte",
          palvelutteksti: "site.palvelutteksti",
          palvelutotsikko: "site.palvelutotsikko",
          osoite: "site.osoite",
          historiaotsikko: "site.historiaotsikko",
          historiateksti: "site.historiateksti",
          historiakuva: "site.historiakuva",
          arkkitehtuuriotsikko: "site.arkkitehtuuriotsikko",
          arkkitehtuuriteksti: "site.arkkitehtuuriteksti",
          arkkitehtuurikuva: "site.arkkitehtuurikuva",
          images: {
            query: "site.images",
            select: {
              id: true,
              filename: true,
              url: true,
              srcset: "file.srcset([300,800,900,1200])"
            }
          }
        }
      },
      //auth: {
      //  username: "api@aurumjewelry.fi",
      //  password: "1Salasana"
      //}
    }
  },
  actions: {
    loadPage() {
      const api = this.api;
      const query = this.query;
      const auth = this.auth;
      axios.post(api, query, { auth }).then((response) => {
        console.log(response.data.result);
        this.site = response.data.result;
      });
    },
  },
})
